/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import Box from "@mui/material/Box";
// @mui/icons-material
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Footer from "components/Footer/TribalismFooter.js";
// sections for this page

import Section4AllClients from "pages-sections/clients-page/Section4AllClients.js";
import styles from "../pages-sections/services/ServicesSections.module.scss";




export default function PricingPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        title="Our Clients - Tribalism"
        image="/img/bg2-sm.webp"
        url="https://www.tribalism.com.au/clients"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. Take a look at some of the clients we have done amazing work for !"

        color="transparent"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />

      <Parallax image="/img/bg2-sm.webp" filter="dark" small>
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              md={8}
              sm={8}
              className={classNames(
                classes.mlAuto,
                classes.mrAuto,
                classes.textCenter
              )}
            >
              <Box sx={{
                '& h1': {
                  fontSize: {
                    xs: '2.3rem',
                    md: '3rem',
                    lg: '4rem'
                  }
                },
                '& h4': {
                  fontSize: {
                    xs: '1.0rem',
                    md: '1.1rem',
                    lg: '1.5rem'
                  }
                }
              }}>
                <h1 className={classes.titleWhite}>Other Clients we work with</h1>
                <h4>
                  We have a wide range of experience across industries (from automotive to kids entertainment), business types (from not-for-profit to listed companies) and business scale (from startups to multinationals).
                </h4>
              </Box>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.containerWide}>
          
          <Section4AllClients />
          <hr />
          
        </div>
      </div>
      <Footer
        
      />

    </div>
  );
}
